var GraphEvent = /** @class */ (function () {
    function GraphEvent(type, event) {
        /**
         * æ¯å¦åè®¸åæ³¡
         * @type {boolean}
         */
        this.bubbles = true;
        /**
         * è§¦åå¯¹è±¡
         * @type {object}
         */
        this.target = null;
        /**
         * çå¬å¯¹è±¡
         * @type {object}
         */
        this.currentTarget = null;
        /**
         * å§æå¯¹è±¡
         * @type {object}
         */
        this.delegateTarget = null;
        /**
         * å§æäºä»¶çå¬å¯¹è±¡çä»£çå¯¹è±¡ï¼å³ ev.delegateObject = ev.currentTarget.get('delegateObject')
         * @type {object}
         */
        this.delegateObject = null;
        /**
         * æ¯å¦é»æ­¢äºåçäºä»¶
         * @type {boolean}
         */
        this.defaultPrevented = false;
        /**
         * æ¯å¦é»æ­¢ä¼ æ­ï¼åä¸åæ³¡ï¼
         * @type {boolean}
         */
        this.propagationStopped = false;
        /**
         * è§¦åäºä»¶çå¾å½¢
         * @type {IShape}
         */
        this.shape = null;
        /**
         * å¼å§è§¦åäºä»¶çå¾å½¢
         * @type {IShape}
         */
        this.fromShape = null;
        /**
         * äºä»¶ç»ææ¶çè§¦åå¾å½¢
         * @type {IShape}
         */
        this.toShape = null;
        // è§¦åäºä»¶çè·¯å¾
        this.propagationPath = [];
        this.type = type;
        this.name = type;
        this.originalEvent = event;
        this.timeStamp = event.timeStamp;
    }
    /**
     * é»æ­¢æµè§å¨é»è®¤çè¡ä¸º
     */
    GraphEvent.prototype.preventDefault = function () {
        this.defaultPrevented = true;
        if (this.originalEvent.preventDefault) {
            this.originalEvent.preventDefault();
        }
    };
    /**
     * é»æ­¢åæ³¡
     */
    GraphEvent.prototype.stopPropagation = function () {
        this.propagationStopped = true;
    };
    GraphEvent.prototype.toString = function () {
        var type = this.type;
        return "[Event (type=" + type + ")]";
    };
    GraphEvent.prototype.save = function () { };
    GraphEvent.prototype.restore = function () { };
    return GraphEvent;
}());
export default GraphEvent;
//# sourceMappingURL=graph-event.js.map